import React from "react";
import { useNavigate } from "react-router-dom";

const NaboraQuickGrid = ({ slug, data }) => {
  const navigate = useNavigate();

  const defaultActions = [
    {
      key: "merchant",
      icon: "🏪",
      label: "Enroll Merchant",
      color: "from-violet-500 to-purple-600",
      type: "route",
      route: "/nabora/merchant",
    },
    {
      key: "exhibitions",
      icon: "🎪",
      label: "Exhibition Days",
      color: "from-amber-500 to-orange-600",
      type: "route",
      route: "/nabora/exhibitions",
    },
    {
      key: "sector",
      icon: "🎯",
      label: "July Sector",
      color: "from-cyan-500 to-blue-600",
      type: "route",
      route: "/nabora/sectors",
    },
    {
      key: "updates",
      icon: "📢",
      label: "Updates",
      color: "from-pink-500 to-rose-600",
      type: "route",
      route: "/nabora/updates",
    },
    {
      key: "coupons",
      icon: "🎟️",
      label: "Coupons",
      color: "from-emerald-500 to-teal-600",
      type: "route",
      route: "/nabora/coupons",
    },
    {
      key: "nearby",
      icon: "📍",
      label: "Find Nearby",
      color: "from-fuchsia-500 to-purple-600",
      type: "route",
      route: "/finditlocal",
    },
    {
      key: "deals",
      icon: "⭐",
      label: "Top Deals",
      color: "from-yellow-400 to-amber-500",
      type: "route",
      route: "/nabora/deals",
    },
    {
      key: "products",
      icon: "🛍️",
      label: "Local Products",
      color: "from-rose-500 to-pink-600",
      type: "route",
      route: "/finditlocal/products",
    },
    {
      key: "organiser",
      icon: "👥",
      label: "Become Organiser",
      color: "from-indigo-500 to-violet-600",
      type: "route",
      route: "/nabora/organiser",
    },
    {
      key: "advertise",
      icon: "📣",
      label: "Advertise",
      color: "from-teal-500 to-cyan-600",
      type: "route",
      route: "/nabora/advertise",
    },
    {
      key: "partners",
      icon: "🤝",
      label: "Partners",
      color: "from-lime-500 to-green-600",
      type: "route",
      route: "/nabora/partners",
    },
    {
      key: "finditlocal",
      icon: "🛍️",
      label: "FindItLocal",
      color: "from-red-500 to-rose-600",
      type: "route",
      route: "/finditlocal",
    },
    {
      key: "support",
      icon: "❤️",
      label: "Support Local",
      color: "from-red-500 to-rose-600",
      type: "route",
      route: "/nabora/support-local",
    },
  ];

  const actions = data || defaultActions;

  const handleAction = (action) => {
    switch (action.type) {
      case "route":
        if (action.route) {
          navigate(action.route);
        }
        break;

      case "modal":
        // console.log("Open modal:", action.key);
        break;

      case "api":
        // console.log("API action:", action.key);
        break;

      case "subscription":
        // console.log("Subscription check:", action.key);
        break;

      default:
        break;
    }
  };

  return (
    <div className="py-2 px-6 bg-slate-950">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-center text-cyan-200 text-xl lg:text-2xl font-bold tracking-tight mb-4">
          Discover. Connect. Grow.
        </h2>

        <div className="grid grid-cols-3 lg:grid-cols-6 gap-2">
          {actions.map((action) => (
            <div
              key={action.key}
              onClick={() => handleAction(action)}
              className="group bg-slate-900/80 hover:bg-slate-800 border border-white/10 hover:border-purple-400/50 rounded-3xl p-3 transition-all duration-300 cursor-pointer flex flex-col items-center justify-center text-center min-h-[120px] relative overflow-hidden"
            >
              <div className="text-lg lg:text-xl mb-2 text-gray-100 transition-transform group-hover:scale-110">
                {action.icon}
              </div>

              <div className="font-semibold text-sm lg:text-lg text-gray-200">
                {action.label}
              </div>

              <div
                className={`absolute inset-0 bg-gradient-to-br ${action.color} opacity-0 group-hover:opacity-10 transition-opacity pointer-events-none`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NaboraQuickGrid;
